import styled from 'styled-components'

export const Header = styled.div`
	margin: 56px 0;
	padding: 32px;
	display: flex;
	justify-content: center;
`
